export default "__VITE_ASSET__BdWgAoCL__"